import { createContext, ReactNode, useContext, useState } from 'react';

import { TCheckoutContext } from './types';

const CheckoutContext = createContext<TCheckoutContext | undefined>(undefined);

export const CheckoutProvider = ({ children }: { children: ReactNode }) => {
  const [merchantLogoUrl, setMerchantLogoUrl] = useState<string | undefined>(undefined);
  const [onBack, setOnBackState] = useState<(() => void) | undefined>(undefined);

  // Wrap the setter so React doesn't interpret the stored function as an updater
  const setOnBack = (fn: (() => void) | undefined) => setOnBackState(() => fn);

  return (
    <CheckoutContext.Provider value={{ merchantLogoUrl, setMerchantLogoUrl, onBack, setOnBack }}>
      {children}
    </CheckoutContext.Provider>
  );
};

export const useCheckout = (): TCheckoutContext => {
  const context = useContext(CheckoutContext);

  if (!context) throw new Error('useCheckout must be used within a CheckoutProvider');
  return context;
};
